module.exports = __webpack_public_path__ + "img/7-onebg.ba69dfab.jpg";